<div class="bad">
  <div class="bad__header">
    <h2 class="bad__title">{{ title }}</h2>
    <button type="button" class="bad__close" (click)="onCancel()" aria-label="Close">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" stroke-width="2" stroke-linecap="round"></line>
        <line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" stroke-width="2" stroke-linecap="round"></line>
      </svg>
    </button>
  </div>

  <div class="bad__body">
    <div class="bad__tabs" role="tablist">
      <button type="button" class="bad__tab" [class.bad__tab--active]="mode === 'record'" (click)="setMode('record')" role="tab">
        Someone in Yeehro
      </button>
      <button type="button" class="bad__tab" [class.bad__tab--active]="mode === 'guest'" (click)="setMode('guest')" role="tab">
        Someone else
      </button>
    </div>

    @if (mode === 'record') {
      <p class="bad__hint">Pick the type of record, then search for the person on the next step.</p>

      @if (loadingModules) {
        <div class="bad__empty">Loading types…</div>
      } @else if (!modules?.length) {
        <div class="bad__empty">No record types available.</div>
      } @else {
        <div class="bad__options">
          @for (_module of modules; track _module?._id) {
            <button type="button" class="bad__option" [class.bad__option--selected]="isModuleSelected(_module)" (click)="selectModule(_module)">
              <span class="bad__option-label">{{ _module?.label }}</span>
              @if (isModuleSelected(_module)) {
                <svg class="bad__option-check" width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path d="M5 12 L10 17 L19 7" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              }
            </button>
          }
        </div>
      }
    } @else {
      <p class="bad__hint">The meeting is booked with these details only. Nothing is created in Yeehro.</p>

      <div class="bad__field">
        <label class="bad__label" for="bad-guest-name">Name</label>
        <input id="bad-guest-name" type="text" class="bad__input" [class.bad__input--error]="showGuestErrors && guestNameInvalid"
          [(ngModel)]="guestName" name="guestName" placeholder="Jordan Avery" autocomplete="off">
        @if (showGuestErrors && guestNameInvalid) {
          <span class="bad__error">Enter a name.</span>
        }
      </div>

      <div class="bad__field">
        <label class="bad__label" for="bad-guest-email">Email</label>
        <input id="bad-guest-email" type="email" class="bad__input" [class.bad__input--error]="showGuestErrors && guestEmailInvalid"
          [(ngModel)]="guestEmail" name="guestEmail" placeholder="jordan@example.com" autocomplete="off">
        @if (showGuestErrors && guestEmailInvalid) {
          <span class="bad__error">Enter an email address so the confirmation can reach them.</span>
        }
      </div>

      <div class="bad__field">
        <label class="bad__label" for="bad-guest-phone">Phone <span class="bad__optional">(optional)</span></label>
        <input id="bad-guest-phone" type="tel" class="bad__input" [(ngModel)]="guestPhone" name="guestPhone" placeholder="(555) 555-5555" autocomplete="off">
      </div>
    }
  </div>

  <div class="bad__actions">
    <button type="button" class="bad__btn bad__btn--secondary" (click)="onCancel()">Cancel</button>
    <button type="button" class="bad__btn bad__btn--primary" [disabled]="!canContinue" (click)="onContinue()">Continue</button>
  </div>
</div>
